<!--Copyright (c) Laserfiche.
Licensed under the MIT License. See LICENSE in the project root for license information.-->

<mat-toolbar color="primary" class="documentation-font">
  <mat-toolbar-row>
    <a [href]="landingPageUrl">
      <span class="material-icons lf-doc-arrow-back"> arrow_back </span>
    </a>
    <div class="lf-back-button-vertical-divider"></div>
    <span id="header-title">Laserfiche UI Components</span>
    <span class="spacer"></span>
    <div class="language-selector-container">
      <select id="language-selector" class="lf-dropdown" (change)="setLanguage($any($event.target).value)">
        <option value="">Use browser language</option>
        <option value="ar">عربى</option>
        <option value="cs">čeština (Česko)</option>
        <option value="de">Deutsch</option>
        <option value="el">Ελληνικά</option>
        <option value="en">English</option>
        <option value="es">español</option>
        <option value="fr">français</option>
        <option value="fr-FR">français (France)</option>
        <option value="id">bahasa Indonesia</option>
        <option value="it">italiano</option>
        <option value="ja">日本語</option>
        <option value="ko">한국어</option>
        <option value="ms">bahasa Melayu</option>
        <option value="nl">Nederland</option>
        <option value="pt-BR">português (Brasil)</option>
        <option value="ro">română</option>
        <option value="sr-Latn">srpski</option>
        <option value="th">ไทย</option>
        <option value="tr">Türkçe (Türkiye)</option>
        <option value="vi">Vietnamese (Vietnam)</option>
        <option value="zh-Hans">中文</option>
        <option value="zh-Hant">中文（繁體）</option>
      </select>
      <mat-checkbox class="lf-checkbox debug-mode-checkbox" color="primary" (change)="onCheckboxChange($event)">
        Debug Mode
      </mat-checkbox>
    </div>
    <span class="spacer"></span>
    <div class="theme-selector-container">
      <select id="theme-selector" class="lf-dropdown" (change)="setTheme('theme-selector')">
        <option value="laserfiche">Laserfiche Theme</option>
        <option value="microsoft">Microsoft Theme</option>
      </select>
    </div>
  </mat-toolbar-row>
</mat-toolbar>
<div class="documentation-wrapper">
  <div class="side-nav documentation-font">
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="navigation-tree">
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
        <li class="mat-tree-node">
          <button mat-icon-button disabled></button>
          @if (!node.routerLink && !node.hyperLink) {
            <p>{{ node.name }}</p>
          }
          @if (node.routerLink) {
            <a class="navigation-tree-item" [routerLink]="node.routerLink">{{ node.name }}</a>
          }
          @if (node.hyperLink) {
            <a class="navigation-tree-item" [href]="node.hyperLink" target="_blank">{{ node.name }}</a>
          }
        </li>
      </mat-tree-node>
      <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
        <li>
          <div class="mat-tree-node">
            <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
              @if (treeControl.isExpanded(node)) {
                <span class="material-icons mat-icon-rtl-mirror"> expand_more </span>
              }
              @if (!treeControl.isExpanded(node)) {
                <span class="material-icons mat-icon-rtl-mirror"> navigate_next </span>
              }
            </button>
            @if (!node.routerLink) {
              <p class="navigation-tree-item" matTreeNodeToggle>{{ node.name }}</p>
            }
            @if (node.routerLink) {
              <a class="navigation-tree-item" [routerLink]="node.routerLink">{{ node.name }}</a>
            }
          </div>
          <ul [class.navigation-tree-invisible]="!treeControl.isExpanded(node)">
            <ng-container matTreeNodeOutlet></ng-container>
          </ul>
        </li>
      </mat-nested-tree-node>
    </mat-tree>
  </div>
  <div class="main-content">
    <router-outlet></router-outlet>
  </div>
</div>
